import { render, staticRenderFns } from "./NotificationAlertBlock.vue?vue&type=template&id=7a6aa66e&scoped=true&"
import script from "./NotificationAlertBlock.vue?vue&type=script&lang=js&"
export * from "./NotificationAlertBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlertBlock.vue?vue&type=style&index=0&id=7a6aa66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6aa66e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6aa66e')) {
      api.createRecord('7a6aa66e', component.options)
    } else {
      api.reload('7a6aa66e', component.options)
    }
    module.hot.accept("./NotificationAlertBlock.vue?vue&type=template&id=7a6aa66e&scoped=true&", function () {
      api.rerender('7a6aa66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Notifications/NotificationAlertBlock.vue"
export default component.exports